import { faCcVisa, faCcMastercard } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CARD_ERROR_EXPIRED } from '../../../brands/default/content/components/checkout';
import { splitCC } from '../../../helpers/payment';
import CCIconStyle from './CCIconStyle';

const CardComponent = (card) => {
  return (
    <>
      <div className="col-12 col-sm-8">
        <p>
          {card.cardType === 'Visa' && (
            <FontAwesomeIcon icon={faCcVisa} style={CCIconStyle} />
          )}
          {card.cardType === 'MasterCard' && (
            <FontAwesomeIcon icon={faCcMastercard} style={CCIconStyle} />
          )}
          <strong>{splitCC(card.maskedNumber)}</strong>
        </p>
      </div>
      <div className="col-12 col-sm-4 text-right">
        <strong style={{ color: card.expired ? 'red' : 'black' }}>
          Exp: {card.expirationDate}
        </strong>
        {card.expired && <p>{CARD_ERROR_EXPIRED}</p>}
      </div>
    </>
  );
};

export default CardComponent;
